import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CreateWrapper } from 'components';
import { Images, useGlobalStyles } from 'utils';
import { CreateCarriersInput } from './core';
import { createPageTitle } from './core/constants';
import { RadioButtons } from './core/radioButtons';
import { carrierIntegrationEnums } from '../carrierInfo/core/constants';
import { carrierInfoFragments } from '../carrierInfo/core';
import { vendorEnums } from '../../../pages';

export const CreateCarrier = ({}) => {
  const globalStyle = useGlobalStyles();
  const [name, setName] = useState('');
  const history = useHistory();
  const info = history?.location?.state;
  const pageInformation = createPageTitle(info?.vendorType);
  const [integration, setIntegration] = useState(carrierIntegrationEnums?.RMIS);
  const classes = carrierInfoFragments();

  return (
    <div>
      <CreateWrapper
        head={
        <div className={'space-between'}>
          <div className={globalStyle.createOfficeTableHead}>
            <img src={Images.carrierBold} alt={'Carrier'} />
            <p>{name ? name : pageInformation?.title}</p>
          </div>

          {info?.vendorType === vendorEnums.CARRIER &&
            <div className={classes.integrationChoice}>
              <RadioButtons
                handleSelect={() => setIntegration(carrierIntegrationEnums?.RMIS)}
                one={true}
                check={integration === carrierIntegrationEnums?.RMIS}
                label={'RMIS'}
                radioColor={'#FFC107'}
              />
              <div className={classes.integrationChoiceLine} />
              <RadioButtons
                handleSelect={() => setIntegration(carrierIntegrationEnums?.GO_HIGHWAY)}
                one={true}
                check={integration === carrierIntegrationEnums?.GO_HIGHWAY}
                label={'GoHighway'}
                radioColor={'#FFC107'}
              />
              <div className={classes.integrationChoiceLine} />
              <RadioButtons
                handleSelect={() => setIntegration(carrierIntegrationEnums?.NONE)}
                one={true}
                check={integration === carrierIntegrationEnums?.NONE}
                label={'None'}
                radioColor={'#FFC107'}
              />
            </div>
          }

        </div>
        }
        body={
          <CreateCarriersInput
            handleChangeName={setName}
            integration={integration}
          />
        }
        parentLink={'/carriers'}
        parent={'Carriers'}
        child={'Add Carrier'}
      />
    </div>
  );
};
